export const TOUR_CUSTOMER_BOOKING_DETAILS_API_START = "TOUR_CUSTOMER_BOOKING_DETAILS_API_START";
export const TOUR_CUSTOMER_BOOKING_DETAILS_API_SUCCESS = "TOUR_CUSTOMER_BOOKING_DETAILS_API_SUCCESS";
export const TOUR_CUSTOMER_BOOKING_DETAILS_API_ERROR = "TOUR_CUSTOMER_BOOKING_DETAILS_API_ERROR";